export default "__VITE_ASSET__CoO8HLUZ__"